import React, { Component } from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row } from 'reactstrap';
import {
  BarChart,
  Bar,
  Cell,
  PieChart,
  Pie,
  ResponsiveContainer,
  XAxis,
  YAxis } from 'recharts';

// Chart Data
const totalsData = [
  { name: 'Applications', value: 1203 },
  { name: 'Approved', value: 473 },
  { name: 'Funded', value: 288 },
];
const pieColors = ['#9CC4F1', '#04BC6C', '#3989E3'];

const top5Data1 = [{ name: 'American Dental – Hollywood', apps: 128, approved: 61 }];
const top5Data2 = [{ name: 'American Dental – Tampa', apps: 116, approved: 56 }];
const top5Data3 = [{ name: 'American Dental – Brooklyn', apps: 102, approved: 48 }];
const top5Data4 = [{ name: 'American Dental – Gold Coast', apps: 88, approved: 42 }];
const top5Data5 = [{ name: 'American Dental – San Diego', apps: 65, approved: 33 }];

class CorpDashboard extends Component {
  componentWillUnmount() {
    sessionStorage.setItem('visitedDashboard', true);
  }
  render() {
    const visitedDashboard = sessionStorage.getItem('visitedDashboard');

    return (
      <div className={ `page-dashboard ${ visitedDashboard ? 'noAnimations' : '' }` }>

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={6} className="text-center text-md-left animated fadeInUp">
              <h3>Welcome, American Dental Inc!</h3>
            </Col>
            <Col md={6} className="text-right d-none d-md-flex justify-content-end align-items-center animated fadeInUp delay-2s">
              <h5 className="mb-0">Corporate ID:  <span className="text-primary">39382683</span></h5>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <div className="animated fadeInUp delay-200ms">
                <Card id="StartCTACard" inverse color="primary" tag="a" href="#">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <div className="icon-bubble mr-2">
                        <img src="../icons/lusa-logo.svg" alt="LendingUSA" className="m-1" width="35" />
                      </div>
                      <h3 className="text-white mb-0">Enroll A New Location</h3>
                    </div>
                  </CardBody>
                </Card>
              </div>

              <Card className="animated fadeInUp delay-300ms">
                <ListGroup>
                  <ListGroupItem tag="a" href="/applications" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="../icons/review.svg" alt="Review" /></div>
                    <div>
                      <h5 className="mb-0">Reports</h5>
                      <small>Lorem ipsum dolor sit amet</small>
                    </div>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/brochures" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="../icons/refunds.svg" alt="Request Brochures" /></div>
                    <div>
                      <h5 className="mb-0">Refunds</h5>
                      <small>Lorem ipsum dolor sit amet</small>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </Card>

              <Card id="Support" className="animated fadeInUp delay-700ms">
                <CardHeader>Your Relationship Manager</CardHeader>
                <CardBody>
                  <p className="mb-0"><strong>Daniel Anderson</strong><br/>
                  <a href="/">d.anderson@lendingusa.com</a><br />
                  888-123-4567 ext. 394</p>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card className="animated fadeInUp delay-500ms">
                <CardHeader>Top 5 Merchants – Applications</CardHeader>
                <ButtonGroup size="sm" className="d-flex">
                  <Button color="primary" active>MTD</Button>
                  <Button color="primary">YTD</Button>
                </ButtonGroup>
                <CardBody className="no-border pt-2 pb-2">
                  <h5>American Dental – Hollywood</h5>
                  <Row>
                    <Col xs={10} lg={9} xl={10} className="pr-0">
                      <ResponsiveContainer width="100%" height={30}>
                        <BarChart
                          data={top5Data1}
                          layout="vertical"
                          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                          height={30}
                          barSize={10}
                        >
                          <XAxis type="number" height={0} domain={[0, 140]} />
                          <YAxis dataKey="name" type="category" width={0} />
                          <Bar dataKey="apps" fill="#9CC4F1" background={{ fill: '#F5F9FD' }} radius={3} />
                          <Bar dataKey="approved" fill="#04BC6C" background={{ fill: '#F5F9FD' }} radius={3} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col xs={2} lg={3} xl={2} className="text-right" style={{ lineHeight: '0.9' }}>
                      <small className="text-secondary font-weight-bold">128</small><br/>
                      <small className="text-success font-weight-bold">61</small>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="pt-2 pb-2">
                  <h5>American Dental – Tampa</h5>
                  <Row>
                    <Col xs={10} lg={9} xl={10} className="pr-0">
                      <ResponsiveContainer width="100%" height={30}>
                        <BarChart
                          data={top5Data2}
                          layout="vertical"
                          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                          height={30}
                          barSize={10}
                        >
                          <XAxis type="number" height={0} domain={[0, 140]} />
                          <YAxis dataKey="name" type="category" width={0} />
                          <Bar dataKey="apps" fill="#9CC4F1" background={{ fill: '#F5F9FD' }} radius={3} />
                          <Bar dataKey="approved" fill="#04BC6C" background={{ fill: '#F5F9FD' }} radius={3} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col xs={2} lg={3} xl={2} className="text-right" style={{ lineHeight: '0.9' }}>
                      <small className="text-secondary font-weight-bold">116</small><br/>
                      <small className="text-success font-weight-bold">56</small>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="pt-2 pb-2">
                  <h5>American Dental – Brooklyn</h5>
                  <Row>
                    <Col xs={10} lg={9} xl={10} className="pr-0">
                      <ResponsiveContainer width="100%" height={30}>
                        <BarChart
                          data={top5Data3}
                          layout="vertical"
                          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                          height={30}
                          barSize={10}
                        >
                          <XAxis type="number" height={0} domain={[0, 140]} />
                          <YAxis dataKey="name" type="category" width={0} />
                          <Bar dataKey="apps" fill="#9CC4F1" background={{ fill: '#F5F9FD' }} radius={3} />
                          <Bar dataKey="approved" fill="#04BC6C" background={{ fill: '#F5F9FD' }} radius={3} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col xs={2} lg={3} xl={2} className="text-right" style={{ lineHeight: '0.9' }}>
                      <small className="text-secondary font-weight-bold">102</small><br/>
                      <small className="text-success font-weight-bold">48</small>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="pt-2 pb-2">
                  <h5>American Dental – Gold Coast</h5>
                  <Row>
                    <Col xs={10} lg={9} xl={10} className="pr-0">
                      <ResponsiveContainer width="100%" height={30}>
                        <BarChart
                          data={top5Data4}
                          layout="vertical"
                          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                          height={30}
                          barSize={10}
                        >
                          <XAxis type="number" height={0} domain={[0, 140]} />
                          <YAxis dataKey="name" type="category" width={0} />
                          <Bar dataKey="apps" fill="#9CC4F1" background={{ fill: '#F5F9FD' }} radius={3} />
                          <Bar dataKey="approved" fill="#04BC6C" background={{ fill: '#F5F9FD' }} radius={3} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col xs={2} lg={3} xl={2} className="text-right" style={{ lineHeight: '0.9' }}>
                      <small className="text-secondary font-weight-bold">88</small><br/>
                      <small className="text-success font-weight-bold">42</small>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="pt-2 pb-2">
                  <h5>American Dental – San Diego</h5>
                  <Row>
                    <Col xs={10} lg={9} xl={10} className="pr-0">
                      <ResponsiveContainer width="100%" height={30}>
                        <BarChart
                          data={top5Data5}
                          layout="vertical"
                          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                          height={30}
                          barSize={10}
                        >
                          <XAxis type="number" height={0} domain={[0, 140]} />
                          <YAxis dataKey="name" type="category" width={0} />
                          <Bar dataKey="apps" fill="#9CC4F1" background={{ fill: '#F5F9FD' }} radius={3} />
                          <Bar dataKey="approved" fill="#04BC6C" background={{ fill: '#F5F9FD' }} radius={3} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col xs={2} lg={3} xl={2} className="text-right" style={{ lineHeight: '0.9' }}>
                      <small className="text-secondary font-weight-bold">65</small><br/>
                      <small className="text-success font-weight-bold">33</small>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card className="animated fadeInUp delay-400ms">
                <CardHeader>Loan Stats</CardHeader>
                <ButtonGroup size="sm" className="d-flex">
                  <Button color="primary" active>MTD</Button>
                  <Button color="primary">YTD</Button>
                </ButtonGroup>
                <CardBody className="no-border">
                  <Row>
                    <Col xs={4} style={{ maxHeight: '120' }}>
                      <ResponsiveContainer>
                        <PieChart>
                          <Pie
                            data={totalsData}
                            innerRadius="70%"
                            outerRadius="108%"
                            paddingAngle={2}
                            startAngle={270}
                            endAngle={-90}
                            dataKey="value"
                          >
                            { totalsData.map((entry, index) => <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />) }
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col>
                      <Row>
                        <Col><h5 className="mb-1">Applications</h5></Col>
                        <Col className="text-right"><h5 style={{ color: pieColors[0] }}>{ totalsData[0].value }</h5></Col>
                      </Row>
                      <Row>
                        <Col><h5 className="mb-1">Approved</h5></Col>
                        <Col className="text-right"><h5 style={{ color: pieColors[1] }}>{ totalsData[1].value }</h5></Col>
                      </Row>
                      <Row>
                        <Col><h5 className="mb-1">Funded</h5></Col>
                        <Col className="text-right"><h5 style={{ color: pieColors[2] }}>{ totalsData[2].value }</h5></Col>
                      </Row>
                      <Row>
                        <Col><h5 className="mb-0">Amount</h5></Col>
                        <Col className="text-right"><h5 className="text-primary mb-0">$1,293,483</h5></Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="animated fadeInUp delay-600ms">
                <CardHeader>Top 5 Merchants – Funding Amount</CardHeader>
                <ButtonGroup size="sm" className="d-flex">
                  <Button color="primary" active>MTD</Button>
                  <Button color="primary">YTD</Button>
                </ButtonGroup>
                <CardBody className="no-border">
                  <Row>
                    <Col><h5 className="mb-1">American Dental – Tampa</h5></Col>
                    <Col xs="auto" className="text-right"><h5 className="text-primary">$394,483</h5></Col>
                  </Row>
                  <Row>
                    <Col><h5 className="mb-1">American Dental – Hollywood</h5></Col>
                    <Col xs="auto" className="text-right"><h5 className="text-primary">$288,927</h5></Col>
                  </Row>
                  <Row>
                    <Col><h5 className="mb-1">American Dental – Gold Coast</h5></Col>
                    <Col xs="auto" className="text-right"><h5 className="text-primary">$198,283</h5></Col>
                  </Row>
                  <Row>
                    <Col><h5 className="mb-1">American Dental – Brooklyn</h5></Col>
                    <Col xs="auto" className="text-right"><h5 className="text-primary">$288,927</h5></Col>
                  </Row>
                  <Row>
                    <Col><h5 className="mb-0">American Dental – San Diego</h5></Col>
                    <Col xs="auto" className="text-right"><h5 className="text-primary mb-0">$92,933</h5></Col>
                  </Row>
                </CardBody>
              </Card>

            </Col>
          </Row>

        </Container>

      </div>
    );
  }
}

export default CorpDashboard;
